<script lang="ts">
    import {searchCustomers} from "$lib/calls/customer.js";
    import {currentCustomer, userCustomer} from "$lib/stores/customer";
    import AsyncTypeAhead from "$lib/components/AsyncTypeAhead.svelte";

    let showCustomerSelection;
    let localCustomer = {registryName: ''};
    /*currentCustomer.subscribe(val => {
        if(val){
            localCustomer = val;
        }
    })*/
</script>
{#if localCustomer}
    <h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Kundenauswahl</h3>
<AsyncTypeAhead label="Projektkunde" call={searchCustomers}
                icon="building-solid"
                displayProperty="registryName"
                bind:value={localCustomer.registryName}
                extract={item => {
                    $currentCustomer = item
                }}
                let:item>
    <div>
        <span class="font-medium pr-2">{item.registry}</span>
        <span>{item.name}</span>
    </div>
</AsyncTypeAhead>
{/if}